import { Column, Entity, PrimaryGeneratedColumn } from "typeorm"

@Entity()
export class RouterData {
  
  @PrimaryGeneratedColumn()
	id!: number;
  
  @Column()
  imei?: string

  @Column({nullable : true})
	signalDbm?: string

  @Column({nullable : true})
	network?: string

  @Column({nullable : true})
  plmn?: string

  @Column({nullable : true})
  lac?: string

  @Column({nullable : true})
  cellid?: string

  @Column('datetime')
	timestamp!: Date
}